// extracted by mini-css-extract-plugin
export var productImage = "_yc-0";